// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import timeEntryTimesheetEntity from './entities/time-entry-timesheet.json';
import timeEntryTimesheetMenu from '../pages/time-entry-timesheet/menu.json';
import timeEntryTimesheetFullForm from '../pages/time-entry-timesheet/forms/full.json';
import timeEntryTimesheetContextForm from '../pages/time-entry-timesheet/forms/context.json';
import timeEntryTimesheetMiniForm from '../pages/time-entry-timesheet/forms/mini.json';
import timeEntryTimesheetLookupForm from '../pages/time-entry-timesheet/forms/lookup.json';
import timeEntryTimesheetTableView from '../pages/time-entry-timesheet/views/table.json';
import timeEntryTimesheetCardsView from '../pages/time-entry-timesheet/views/cards.json';
import timeEntryTimesheetDashboardView from '../pages/time-entry-timesheet/views/dashboard.json';

/** Тип запису «Табель» зі сторінками пакета: меню, форми та подання з pages/time-entry-timesheet/. */
export const timeEntryTimesheetDefinition: IRecordTypeDefinition = {
  ...timeEntryTimesheetEntity,
  views: assembleViewSet({
      table: timeEntryTimesheetTableView,
      cards: timeEntryTimesheetCardsView,
      dashboard: timeEntryTimesheetDashboardView,
  }),
  form: timeEntryTimesheetFullForm,
  forms: { full: timeEntryTimesheetFullForm, context: timeEntryTimesheetContextForm, mini: timeEntryTimesheetMiniForm, lookup: timeEntryTimesheetLookupForm },
  menu: timeEntryTimesheetMenu,
} as IRecordTypeDefinition;
